// src/pages/home/Home.js

import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getInstitucional, getInformativos } from '../../services/api';
import matriz from '../../assets/matriz.png';
import parocoFoto from '../../assets/paroco.png';

/* ── Dados padrão ─────────────────────────────────────────────────────────── */

const HISTORICO_RESUMO = `<p>Messejana originou-se de uma aldeia de índios Potiguaras que já existia antes da chegada do capitão-mor Pero Coelho de Souza, em <strong>1603</strong>. Em 1607, os padres jesuítas <strong>Francisco Pinto</strong> e <strong>Luís Figueira</strong> passaram pela região em missão catequética, deixando marcas profundas na história local.</p>
<p>O nome <strong>Paupina</strong> — primeira denominação da região — deriva de <em>"Pai Pina"</em>, forma como os indígenas se referiam ao padre Francisco Pinto, morto em <strong>11 de janeiro de 1608</strong>. Já o nome <strong>Messejana</strong> surgiu oficialmente em <strong>10 de janeiro de 1760</strong>, com a criação da Vila Nova Real de Messejana da América.</p>
<h4 style="color:#1a3a6b;margin:1.5rem 0 0.5rem">Fundação da Paróquia</h4>
<p>A primeira freguesia de Messejana foi criada pelo Bispo de Olinda, <strong>Dom Francisco Xavier Aranha</strong>, em <strong>5 de fevereiro de 1759</strong>, tendo como padroeira <strong>Nossa Senhora da Conceição</strong>. A atual paróquia foi instituída canonicamente em <strong>20 de fevereiro de 1873</strong>, por provisão episcopal de Dom Luís Antônio dos Santos.</p>`;

const HISTORICO_EXTRA = `<h4 style="color:#1a3a6b;margin:1.5rem 0 0.5rem">Cônego Francisco Pereira da Silva (1938)</h4>
<p>Em 1938, assumiu a paróquia o <strong>Cônego Francisco</strong>, permanecendo por mais de 40 anos. Entre suas realizações: reforma da igreja matriz, instalação do relógio da torre, construção do Salão Paroquial Pio X (1954) e da Casa Paroquial.</p>
<h4 style="color:#1a3a6b;margin:1.5rem 0 0.5rem">Monsenhor Antônio Souto</h4>
<p>Destacou-se pelo trabalho missionário e pela proximidade com as comunidades, construindo o <strong>Centro de Formação da Região Metropolitana III</strong>, inaugurado em 1987.</p>
<h4 style="color:#1a3a6b;margin:1.5rem 0 0.5rem">Párocos Subsequentes</h4>
<ul style="color:#6b6860;line-height:2;padding-left:1.25rem">
  <li><strong>Pe. José Maria Cavalcante</strong> — 1990</li>
  <li><strong>Monges Beneditinos</strong> — 1992 a 1995</li>
  <li><strong>Pe. Alderi Leite</strong> — a partir de 2 de julho de 1995</li>
  <li><strong>Pe. Daniel Morais</strong> — 10 de fevereiro de 2006 a 2013</li>
  <li><strong>Pe. Emílio César Porto Cabral</strong> — 2014 a 2019</li>
</ul>
<h4 style="color:#1a3a6b;margin:1.5rem 0 0.5rem">Pe. João Batista Aires Silva (2020 – atualidade)</h4>
<p>Em <strong>2020</strong>, assumiu o padre <strong>João Batista Aires Silva</strong>, dando continuidade ao trabalho pastoral, à evangelização e ao fortalecimento das comunidades paroquiais.</p>`;

const INFORMATIVOS_DEFAULT = [];

const TIPO_CONFIG = {
  aviso:    { cor: '#c9a030', bg: '#f5e9c8', label: 'Aviso',    icon: '📌' },
  evento:   { cor: '#1a3a6b', bg: '#e8eef7', label: 'Evento',   icon: '🗓' },
  pastoral: { cor: '#1e7d4f', bg: '#eafaf1', label: 'Pastoral', icon: '✝️' },
  urgente:  { cor: '#c0392b', bg: '#fdedec', label: 'Urgente',  icon: '🔔' },
};

/* ── Hero ──────────────────────────────────────────────────────────────────── */
const Hero = () => (
  <section style={{
    minHeight: '100vh',
    background: 'linear-gradient(160deg, var(--navy-dark) 0%, var(--navy) 50%, #1e3566 100%)',
    display: 'flex', alignItems: 'center',
    position: 'relative', overflow: 'hidden', paddingTop: '72px',
  }}>
    <div style={{ position: 'absolute', inset: 0, backgroundImage: 'radial-gradient(circle, rgba(201,160,48,0.07) 1px, transparent 1px)', backgroundSize: '40px 40px', pointerEvents: 'none' }} />
    <div className="container" style={{ position: 'relative', zIndex: 1 }}>
      <div className="hero-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 'var(--space-3xl)', alignItems: 'center' }}>
        <div>
          <div className="ornament" style={{ marginBottom: '1.5rem', color: 'var(--gold)', fontSize: '0.875rem', letterSpacing: '0.12em', textTransform: 'uppercase' }}>
            Bem-vindo à
          </div>
          <h1 style={{ fontFamily: 'var(--font-display)', color: 'var(--white)', marginBottom: '1rem', fontSize: 'clamp(2rem, 5vw, 3.6rem)', lineHeight: 1.1 }}>
            Paróquia<br /><span style={{ color: 'var(--gold)' }}>Nossa Senhora</span><br />da Conceição
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: 'clamp(0.95rem, 1.8vw, 1.1rem)', maxWidth: '480px', marginBottom: '2.5rem', lineHeight: 1.8 }}>
            Uma comunidade unida na fé, no amor e na esperança. Venha celebrar os sacramentos e crescer espiritualmente conosco em Messejana desde 1603.
          </p>
          <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
            <Link to="/sacramentos" className="btn btn-primary btn-lg">✦ Sacramentos</Link>
            <Link to="/batismo" className="btn btn-secondary btn-lg">Inscrição para Batismo</Link>
          </div>
        </div>
        <div className="hide-mobile" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative' }}>
          <div style={{ position: 'absolute', width: '420px', height: '420px', borderRadius: '50%', border: '2px solid rgba(201,160,48,0.2)', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />
          <div style={{ position: 'absolute', width: '360px', height: '360px', borderRadius: '50%', border: '1px solid rgba(201,160,48,0.12)', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />
          <img src={matriz} alt="Igreja Matriz" style={{ width: '100%', maxWidth: '380px', objectFit: 'contain', filter: 'drop-shadow(0 8px 40px rgba(0,0,0,0.5))', position: 'relative', zIndex: 1, animation: 'floatImg 4s ease-in-out infinite' }} />
          <style>{`@keyframes floatImg { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-10px)} }`}</style>
        </div>
      </div>
    </div>
    <div style={{ position: 'absolute', bottom: '2rem', left: '50%', transform: 'translateX(-50%)', color: 'rgba(255,255,255,0.4)', fontSize: '0.75rem', animation: 'bounce 2s infinite' }}>▼</div>
    <style>{`@keyframes bounce { 0%,100%{transform:translateX(-50%) translateY(0)} 50%{transform:translateX(-50%) translateY(6px)} }`}</style>
  </section>
);

/* ── Quick Links ───────────────────────────────────────────────────────────── */
const QUICK = [
  { to: '/batismo',      icon: '🕊️', label: 'Batismo',         desc: 'Inscrições para o Sacramento' },
  { to: '/noivos',       icon: '💍', label: 'Curso de Noivos', desc: 'Preparação para o Matrimônio' },
  { to: '/capelas',      icon: '⛪', label: 'Comunidades',      desc: 'Conheça nossas Comunidades' },
  { to: '/solicitacoes', icon: '📜', label: 'Solicitações',     desc: 'Batistério e Declarações' },
];

const QuickLinks = () => (
  <section style={{ background: 'var(--off-white)', padding: 'var(--space-2xl) 0' }}>
    <div className="container">
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 'var(--space-lg)', alignItems: 'stretch' }}>
        {QUICK.map(({ to, icon, label, desc }) => (
          <Link key={to} to={to} style={{ textDecoration: 'none' }}>
            <div className="card" style={{ padding: 'var(--space-xl)', textAlign: 'center', borderTop: '4px solid var(--gold)', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '160px' }}>
              <div style={{ fontSize: '2.5rem', marginBottom: '0.75rem' }}>{icon}</div>
              <h3 style={{ fontSize: '1.1rem', marginBottom: '0.5rem' }}>{label}</h3>
              <p style={{ fontSize: '0.875rem', color: 'var(--gray-400)' }}>{desc}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

/* ── Quadro de Informativos ────────────────────────────────────────────────── */
const Informativos = ({ avisos }) => {
  // null = ainda carregando, [] = carregado e vazio
  if (avisos === null) return null;
  const lista = avisos;

  return (
    <section style={{ background: 'var(--navy-dark)', padding: 'var(--space-2xl) var(--space-xl)', position: 'relative', overflow: 'hidden' }}>
      {/* Textura de madeira/cortiça simulada */}
      <div style={{ position: 'absolute', inset: 0, backgroundImage: 'repeating-linear-gradient(45deg, rgba(201,160,48,0.03) 0px, rgba(201,160,48,0.03) 1px, transparent 1px, transparent 8px)', pointerEvents: 'none' }} />

      <div className="container" style={{ position: 'relative' }}>
        {/* Cabeçalho do quadro */}
        <div style={{ textAlign: 'center', marginBottom: 'var(--space-xl)' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.75rem', background: 'rgba(201,160,48,0.1)', border: '1px solid rgba(201,160,48,0.3)', borderRadius: 'var(--radius-lg)', padding: '0.5rem 1.5rem', marginBottom: '0.75rem' }}>
            <span style={{ fontSize: '1.1rem' }}>📋</span>
            <span style={{ color: 'var(--gold)', fontSize: '0.8rem', fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase' }}>Mural de Avisos</span>
          </div>
          <h2 style={{ color: 'var(--white)', fontFamily: 'var(--font-display)', fontSize: 'clamp(1.4rem, 3vw, 1.9rem)', marginBottom: '0.25rem' }}>Informativos da Paróquia</h2>
          <p style={{ color: 'rgba(255,255,255,0.45)', fontSize: '0.875rem' }}>Fique por dentro das novidades e eventos da nossa comunidade</p>
        </div>

        {/* Grid de avisos — estilo post-its/fichas */}
        {lista.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 'var(--space-xl)', color: 'rgba(255,255,255,0.35)', fontSize: '0.95rem' }}>
            <div style={{ fontSize: '2rem', marginBottom: '0.75rem', opacity: 0.4 }}>📋</div>
            <p>Nenhum informativo no momento.</p>
          </div>
        ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 'var(--space-lg)', alignItems: 'start' }}>
          {lista.map((aviso) => {
            const cfg = TIPO_CONFIG[aviso.tipo] || TIPO_CONFIG.aviso;
            return (
              <div key={aviso.id} style={{
                background: 'var(--white)',
                borderRadius: 'var(--radius-lg)',
                overflow: 'hidden',
                boxShadow: '0 4px 20px rgba(0,0,0,0.3), 0 1px 4px rgba(0,0,0,0.2)',
                transform: `rotate(${aviso.id % 2 === 0 ? '-0.5' : '0.5'}deg)`,
                transition: 'transform 0.2s, box-shadow 0.2s',
              }}
              onMouseEnter={e => { e.currentTarget.style.transform = 'rotate(0deg) translateY(-4px)'; e.currentTarget.style.boxShadow = '0 8px 32px rgba(0,0,0,0.4)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform = `rotate(${aviso.id % 2 === 0 ? '-0.5' : '0.5'}deg)`; e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.3)'; }}
              >
                {/* Faixa colorida do tipo */}
                <div style={{ background: cfg.cor, padding: '0.5rem 1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <span style={{ fontSize: '0.9rem' }}>{cfg.icon}</span>
                  <span style={{ color: 'var(--white)', fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase' }}>{cfg.label}</span>
                  {/* Alfinete decorativo */}
                  <div style={{ marginLeft: 'auto', width: 10, height: 10, borderRadius: '50%', background: 'rgba(255,255,255,0.4)', border: '2px solid rgba(255,255,255,0.7)' }} />
                </div>
                {/* Conteúdo */}
                <div style={{ padding: '1rem 1.25rem 1.25rem', background: cfg.bg }}>
                  <h4 style={{ color: '#1a2744', fontSize: '0.95rem', marginBottom: '0.5rem', lineHeight: 1.3, fontFamily: 'var(--font-display)' }}>{aviso.titulo}</h4>
                  <p style={{ color: '#6b6860', fontSize: '0.85rem', lineHeight: 1.6 }}>{aviso.texto}</p>
                </div>
              </div>
            );
          })}
        </div>
        )}
      </div>
    </section>
  );
};

/* ── Pároco ────────────────────────────────────────────────────────────────── */
const Paroco = ({ info }) => {
  const [isDesktop, setIsDesktop] = React.useState(window.innerWidth >= 641);

  React.useEffect(() => {
    const handler = () => setIsDesktop(window.innerWidth >= 641);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  return (
    <section style={{ background: 'var(--off-white)', padding: 'var(--space-2xl) var(--space-xl)' }}>
      <div className="container" style={{ maxWidth: 700 }}>
        <div style={{
          background: 'var(--white)',
          borderRadius: 'var(--radius-xl)',
          boxShadow: 'var(--shadow-md)',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: isDesktop ? 'row' : 'column',
          alignItems: 'stretch',
        }}>
          {/* Foto */}
          <div style={{
            width: isDesktop ? 220 : '100%',
            height: isDesktop ? 'auto' : 280,
            minHeight: isDesktop ? 220 : 'unset',
            flexShrink: 0,
            position: 'relative',
            overflow: 'hidden',
            background: 'var(--navy-dark)',
          }}>
            <img
              src={info?.parocoFoto || parocoFoto}
              alt="Pároco"
              style={{
                position: 'absolute',
                top: 0, left: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                objectPosition: 'center top',
              }}
            />
            <div style={{
              position: 'absolute', bottom: 0, left: 0, right: 0,
              background: 'rgba(201,160,48,0.92)',
              padding: '0.45rem',
              textAlign: 'center',
            }}>
              <span style={{ color: 'var(--navy-dark)', fontSize: '0.7rem', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase' }}>Pároco</span>
            </div>
          </div>
          {/* Texto */}
          <div style={{ padding: 'var(--space-xl)', textAlign: 'left', flex: 1 }}>
            <div style={{ color: 'var(--gold)', fontSize: '0.75rem', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '0.5rem' }}>
              Palavra do Pároco
            </div>
            <h3 style={{ color: 'var(--navy)', marginBottom: '0.75rem', fontSize: '1.2rem' }}>
              {info?.paroco || 'Pe. João Batista Aires Silva'}
            </h3>
            <p style={{ color: 'var(--gray-600)', fontSize: '0.9rem', lineHeight: 1.8 }}>
              {info?.palavraParoco || 'Sejam bem-vindos à Paróquia Nossa Senhora da Conceição de Messejana. Nossa comunidade está sempre de portas abertas para acolher, evangelizar e celebrar a fé com alegria e fraternidade.'}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

/* ── Histórico ─────────────────────────────────────────────────────────────── */
// Número de caracteres visíveis antes do "Ler mais"
const LIMITE_HISTORICO = 600;

const Historico = ({ texto }) => {
  const [expandido, setExpandido] = useState(false);

  // Se veio do Sheets, usa ele; senão usa o default
  const htmlCompleto = texto || (HISTORICO_RESUMO + HISTORICO_EXTRA);

  // Texto simples (sem tags) para calcular o limite
  const textoSemTags = htmlCompleto.replace(/<[^>]+>/g, '');
  const precisaCorte = textoSemTags.length > LIMITE_HISTORICO;

  // Para o resumo: pega o html até encontrar ~LIMITE caracteres de texto real
  const getResumoHtml = () => {
    if (!precisaCorte) return htmlCompleto;
    let chars = 0;
    let resultado = '';
    // Percorre o html caractere por caractere, contando só o texto fora de tags
    let dentroTag = false;
    for (let i = 0; i < htmlCompleto.length; i++) {
      const c = htmlCompleto[i];
      if (c === '<') { dentroTag = true; resultado += c; continue; }
      if (c === '>') { dentroTag = false; resultado += c; continue; }
      resultado += c;
      if (!dentroTag) {
        chars++;
        if (chars >= LIMITE_HISTORICO) {
          resultado += '...';
          break;
        }
      }
    }
    return resultado;
  };

  return (
    <section style={{ padding: 'var(--space-2xl) var(--space-xl)', background: 'var(--white)' }}>
      <div className="container">
        <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
          <div className="ornament" style={{ justifyContent: 'center', marginBottom: '1rem', color: 'var(--gold)', fontSize: '0.8rem', letterSpacing: '0.1em', textTransform: 'uppercase' }}>
            Nossa História
          </div>
          <h2 className="section-title">Histórico da Paróquia</h2>
          <div style={{ height: '3px', width: '60px', background: 'var(--gold)', margin: '1.5rem auto' }} />
          <div
            style={{ textAlign: 'left', color: 'var(--gray-600)', lineHeight: 1.9, fontSize: '1rem' }}
            dangerouslySetInnerHTML={{ __html: expandido ? htmlCompleto : getResumoHtml() }}
          />
          {precisaCorte && (
            <button
              onClick={() => setExpandido(e => !e)}
              className="btn btn-secondary"
              style={{ marginTop: '2rem' }}
            >
              {expandido ? '▲ Mostrar menos' : '▼ Ler história completa'}
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

/* ── Informações ───────────────────────────────────────────────────────────── */
const Informacoes = ({ info }) => {
  const missas = info?.missas || ['Segunda a Sexta: 17:30', 'Domingo: 7h, 17h e 19h'];
  return (
    <section style={{ background: 'var(--navy)', padding: 'var(--space-2xl) var(--space-xl)' }}>
      <div className="container">
        <h2 className="section-title" style={{ color: 'var(--white)', marginBottom: '3rem' }}>Informações</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 'var(--space-xl)' }}>
          {[
            { icon: '📍', title: 'Endereço',           content: info?.endereco  || 'R. Joaquim Bezerra, 235\nMessejana – CEP 60842-010\nFortaleza – CE' },
            { icon: '📞', title: 'Contato',             content: info?.telefones || '(85) 98134-6247' },
            { icon: '⛪', title: 'Horários das Missas', content: Array.isArray(missas) ? missas.join('\n') : missas },
            { icon: '🗓', title: 'Secretaria',          content: info?.secretaria || 'Segunda a Sexta:\nManhã: 8h às 12h\nTarde: 13h às 17h' },
            { icon: '✝',  title: 'Pároco',              content: info?.paroco    || 'Pe. João Batista Aires Silva' },
          ].map(({ icon, title, content }) => (
            <div key={title} style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(201,160,48,0.2)', borderRadius: 'var(--radius-md)', padding: 'var(--space-xl)' }}>
              <div style={{ fontSize: '1.5rem', marginBottom: '0.75rem' }}>{icon}</div>
              <h4 style={{ color: 'var(--gold)', marginBottom: '0.5rem', fontSize: '0.85rem', letterSpacing: '0.06em', textTransform: 'uppercase' }}>{title}</h4>
              <p style={{ color: 'rgba(255,255,255,0.7)', whiteSpace: 'pre-wrap', fontSize: '0.9rem', lineHeight: 1.7 }}>{content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

/* ── Home Page ─────────────────────────────────────────────────────────────── */
const Home = () => {
  const [info, setInfo] = useState(null);
  const [avisos, setAvisos] = useState(null);

  useEffect(() => {
    getInstitucional()
      .then(r => setInfo(r?.data || null))
      .catch(() => {});
    getInformativos()
      .then(r => setAvisos(r?.data || []))
      .catch(() => setAvisos([]));
  }, []);

  return (
    <>
      <Hero />
      <QuickLinks />
      <Informativos avisos={avisos} />
      <Paroco info={info} />
      <Historico texto={info?.historico} />
      <Informacoes info={info} />
    </>
  );
};

export default Home;